/* global PRODUCTION */
import appColors from "./colors";

export default {
	environments: [
		// { name: 'dev', fullName: 'development', label: 'DEV', cdn: 'https://dev-media.performyard.com', host: 'https://dev.talent.performyard.com' },
		{
			name: "staging",
			fullName: "staging",
			label: "STAGING",
			cdn: "https://dev-media.performyard.com",
			host: "https://staging.talent.performyard.com",
		},
		{
			name: "preview",
			fullName: "preview",
			label: "PREVIEW",
			cdn: "https://dev-media.performyard.com",
			host: "https://preview.talent.performyard.com",
		},
		{
			name: "demo",
			fullName: "demo",
			label: "DEMO",
			cdn: "https://sandbox-media.performyard.com",
			host: "https://demo.talent.performyard.com",
		},
		{
			name: "sandbox",
			fullName: "sandbox",
			label: "SANDBOX",
			cdn: "https://sandbox-media.performyard.com",
			host: "https://sandbox.talent.performyard.com",
		},
		{
			name: "production",
			fullName: "production",
			label: "PRODUCTION",
			cdn: "https://media.performyard.com",
			host: "https://talent.performyard.com",
		},
	],

	dateTimeFormat: "MMM D YYYY h:mm a",
	colors: appColors,
	APIHost: PRODUCTION ? "https://wolverine.talent.performyard.com" : "http://localhost:4000",
};
